import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  name: 'AdoptionApplicationOverlayAsync',
  resolve: () =>
    import(/* webpackChunkName: "AdoptionApplicationOverlay" */ './Overlay')
});
